import React from 'react';
import styles from './ProfileCard.module.css';
import TagBadge from './TagBadge';
import logoImg from '../images/logo.png';

/** Numero massimo di caratteri della bio mostrati in ogni card (uguale per tutte). */
const BIO_PREVIEW_MAX_LENGTH = 120;

const truncate = (text, maxLength = BIO_PREVIEW_MAX_LENGTH) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength).trimEnd()}…`;
};

const ProfileCard = ({ profile, onClick }) => {
  if (!profile) return null;

  const { fullName, bio, profileImageUrl, tags = [] } = profile;

  const professions = tags.filter((t) => t.category === 'profession');
  const skills = tags.filter((t) => t.category === 'skill');
  const hobbies = tags.filter((t) => t.category === 'hobby');

  const previewTags = [professions[0], skills[0], hobbies[0]].filter(Boolean);

  const handleKeyDown = (event) => {
    if (!onClick) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick(event);
    }
  };

  return (
    <div
      className={styles.card}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={handleKeyDown}
    >
      <div className={styles.imageWrapper}>
        <img
          src={profileImageUrl || logoImg}
          alt={profileImageUrl ? fullName || 'Profilo' : 'CIL'}
          className={profileImageUrl ? styles.image : styles.imageLogo}
          loading="lazy"
        />
      </div>
      <div className={styles.body}>
        <h3 className={styles.name}>{fullName}</h3>
        <p className={styles.bio}>{truncate(bio, BIO_PREVIEW_MAX_LENGTH)}</p>
        <div className={styles.tagsSection}>
          {previewTags.length > 0 && (
            <div className={styles.tagsRow}>
              {previewTags.map((tag) => (
                <TagBadge
                  key={tag.id ?? tag.name}
                  label={tag.name}
                  category={tag.category}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
